"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var queue_exports = {};
__export(queue_exports, {
  QueueMeetingEvent: () => QueueMeetingEvent,
  queueEvents: () => queueEvents
});
module.exports = __toCommonJS(queue_exports);
var QueueMeetingEvent = /* @__PURE__ */ ((QueueMeetingEvent2) => {
  QueueMeetingEvent2["started"] = "created";
  QueueMeetingEvent2["finished"] = "finished";
  QueueMeetingEvent2["personJoined"] = "person-joined";
  QueueMeetingEvent2["personLeft"] = "person-left";
  QueueMeetingEvent2["updated"] = "updated";
  QueueMeetingEvent2["recordingStarted"] = "recording-started";
  QueueMeetingEvent2["recordingStopped"] = "recording-stopped";
  QueueMeetingEvent2["languageUpdated"] = "language-updated";
  QueueMeetingEvent2["transcriptionStarted"] = "transcription-started";
  QueueMeetingEvent2["transcriptionFinished"] = "transcription-finished";
  QueueMeetingEvent2["webhook"] = "webhook";
  QueueMeetingEvent2["egressEvent"] = "egress";
  QueueMeetingEvent2["updateMetadata"] = "update-metadata";
  return QueueMeetingEvent2;
})(QueueMeetingEvent || {});
const queueEvents = {
  started: /* @__PURE__ */ __name((meetingId) => ({ type: "created" /* started */, meetingId }), "started"),
  finished: /* @__PURE__ */ __name((meetingId) => ({ type: "finished" /* finished */, meetingId }), "finished"),
  personJoined: /* @__PURE__ */ __name((meetingId, person, identity) => ({
    type: "person-joined" /* personJoined */,
    meetingId,
    person,
    identity
  }), "personJoined"),
  personLeft: /* @__PURE__ */ __name((meetingId, person, identity) => ({
    type: "person-left" /* personLeft */,
    meetingId,
    person,
    identity
  }), "personLeft"),
  updated: /* @__PURE__ */ __name((meetingId) => ({ type: "updated" /* updated */, meetingId }), "updated"),
  recordingStarted: /* @__PURE__ */ __name((meetingId) => ({
    type: "recording-started" /* recordingStarted */,
    meetingId
  }), "recordingStarted"),
  recordingStopped: /* @__PURE__ */ __name((meetingId) => ({
    type: "recording-stopped" /* recordingStopped */,
    meetingId
  }), "recordingStopped"),
  languageUpdated: /* @__PURE__ */ __name((meetingId) => ({
    type: "language-updated" /* languageUpdated */,
    meetingId
  }), "languageUpdated"),
  transcriptionStarted: /* @__PURE__ */ __name((meetingId) => ({
    type: "transcription-started" /* transcriptionStarted */,
    meetingId
  }), "transcriptionStarted"),
  transcriptionFinished: /* @__PURE__ */ __name((meetingId) => ({
    type: "transcription-finished" /* transcriptionFinished */,
    meetingId
  }), "transcriptionFinished"),
  webhook: /* @__PURE__ */ __name((meetingId, webhook) => ({
    type: "webhook" /* webhook */,
    meetingId,
    webhook
  }), "webhook"),
  egressEvent: /* @__PURE__ */ __name((meetingId, egressId, egressStatus, meta) => ({
    type: "egress" /* egressEvent */,
    meetingId,
    egressId,
    egressStatus,
    meta
  }), "egressEvent"),
  updateMetadata: /* @__PURE__ */ __name((meetingId, roomName, metadata) => ({
    type: "update-metadata" /* updateMetadata */,
    roomName,
    meetingId,
    metadata
  }), "updateMetadata")
};
//# sourceMappingURL=queue.js.map
